import ArchiveLayout from '@/layouts/ArchiveLayout';
import { RESOURCES_QUERY } from '@/lib/wordpress';

type Locale = 'en' | 'el';

const title: Record<Locale, string> = {
  en: 'Useful Materials',
  el: 'Χρήσιμο Υλικό',
};

const description: Record<Locale, string> = {
  en: 'Downloadable resources, templates, and reference materials.',
  el: 'Πόροι προς λήψη, πρότυπα και υλικό αναφοράς.',
};

const eyebrow: Record<Locale, string> = {
  en: 'RESOURCES',
  el: 'ΥΛΙΚΟ',
};

const emptyState: Record<Locale, string> = {
  en: 'No resources available at the moment.',
  el: 'Δεν υπάρχει διαθέσιμο υλικό αυτή τη στιγμή.',
};

const ctaText: Record<Locale, string> = {
  en: 'Contact us',
  el: 'Επικοινωνήστε μαζί μας',
};

export default function ResourcesArchive() {
  return (
    <ArchiveLayout
      pageKey="resources"
      postType="resources"
      query={RESOURCES_QUERY}
      title={title}
      description={description}
      eyebrow={eyebrow}
      emptyState={emptyState}
      ctaText={ctaText}
    />
  );
}
